var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-toolbar',{staticClass:"transparent mx-auto mb-4",attrs:{"flat":""}},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.goBack()}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.msg))])],1),(false)?_c('voice-calendar-stats',{staticClass:"mb-4"}):_vm._e(),_c('voice-data-table-stats',{staticClass:"mb-4"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed9605e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
// module id = null
// module chunks = 